/**
 * Wire properties for the Segment destination connector's events.
 *
 * Ember's controller passed camelCase keys and a transform renamed them on the way
 * out (`app/utils/analytics/transforms/integrations.ts`). There is no such
 * transform here, so these are the renamed names the wire actually carries.
 */

/** Every event on this page carries these three. `Destination` is Segment's word for us. */
export const SEGMENT_IN_ANALYTICS_META = {
  'Integration Name': 'Segment',
  'Integration Category': 'Data management',
  'Integration Sub-Category': 'Destination',
} as const;

/**
 * `Re-enabled` only for an explicit re-enable of a disabled destination; creating
 * one, or connecting for the first time, is `Enabled`.
 */
export function enableProperties(isReEnable: boolean) {
  return {
    ...SEGMENT_IN_ANALYTICS_META,
    'Integration Enabled or Re-Enabled': isReEnable ? 'Re-enabled' : 'Enabled',
  };
}

/** Verify carries no extra properties when it starts. */
export function verifyStartedProperties() {
  return { ...SEGMENT_IN_ANALYTICS_META };
}

/**
 * The outcome the reader was shown. Ember read it from the alert it had just set,
 * falling back to the snackbar the auth service raised, because the two halves of
 * the messaging live in different places.
 */
export function verifyCompletedProperties(status: string | undefined) {
  return {
    ...SEGMENT_IN_ANALYTICS_META,
    'Integration Verify Status': status,
  };
}

/** `Disabled` for a disable, `Deleted` when the destination is removed. */
export function disabledProperties(action: 'Disabled' | 'Deleted') {
  return {
    ...SEGMENT_IN_ANALYTICS_META,
    'Integration Disabled or Deleted': action,
  };
}

/** Fired when the disable or delete confirmation opens, before anything happens. */
export function disableStartedProperties(action: 'Disabled' | 'Deleted') {
  return {
    ...SEGMENT_IN_ANALYTICS_META,
    'Integration Disabled or Deleted': action,
  };
}

/** Fired when the clear confirmation opens. It has no completion half. */
export function clearStartedProperties() {
  return { ...SEGMENT_IN_ANALYTICS_META };
}
